<template>
    <div class="web-body">
        <div class="web-header">
            <div class="web-1170">
                <img class="web-logo" :src="this.$api_url+'/static/images/logo.png'">
            </div>
        </div>
        <div class="web-nav">
            <div class="web-1170">
                <Header></Header>
            </div>
        </div>
        <div class="web-content">
            <div class="web-1170" style="min-height: 830px">
                <div class="web-list-left">
                    <h2>{{ title }}</h2>
                    <ul>
                        <li v-for="(item,index) in list" :key="index" :class="generateClassName(item.link)?'active':''"><a :href="item.link">{{ item.title }}</a></li>
                    </ul>
                </div>
                <div class="web-list-right">
                    <h3>{{ content.title }}</h3>
                    <p class="content" v-html="content.content" style="display: inline-block"></p>
                </div>
            </div>
        </div>
        <div class="web-footer">
            <div class="web-1170">
                <Footer></Footer>
            </div>
        </div>
    </div>
</template>

<script>
import("../../../public/css/web.css")
import Footer from "./footer"
import Header from "./header"

export default {
    name: "page_content",
    components: {Footer, Header},
    data() {
        return {
            title: "",
            list: [],
            content: [],
        };
    },
    // 方法集合
    methods: {
        generateClassName(val) {
            if (val == this.content.item) {
                return true
            } else {
                return false
            }
        },
        getList() {
            this.$api.get('/api/web/content-array/', {"id": this.$route.params.id}).then((response) => {
                this.title = response.title
                this.list = response.list
                this.content = response.content
                console.log(response)
            })
        }
    },
    // 生命周期 - 挂载完成
    mounted() {
        this.getList()
    },
}
</script>